import React, { Component } from "react";
import { websiteUrl } from '../../utils/common';

const EditGeoFence = (props) => 
{ 
     const webUrl=websiteUrl();
    
     const strUrl=webUrl+`geofencealertedit.html?AccountID=${props.EditGeofenceobj.accountid}&AlertID=${props.EditGeofenceobj.alertid}`;     
     return ( 
      <>                  
       <iframe width="1100px" height="668px" src={strUrl}  title="ShowGeoFenceInsertIFR" ></iframe>  
       </>       
       )}; 
   
export default EditGeoFence;

